import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { Spinner } from '../shared/Spinner';
import { Bio } from './Bio/Bio';
import { PreCustomGDPR } from './CustomTerms/PreCustomGDPR';
import { CustomGDPR } from './CustomTerms/CustomGDPR';
import { Fairness } from './Fairness/Fairness';
import { TechIssues } from './TechIssues/TechIssues';
import { Terms } from './Terms/Terms';
import { WelcomeText } from './WelcomeText';

import { managementApi } from '../../utils/agent';

const preTestReducer = (state, action) => {
  switch (action.type) {
    case 'PASS_WELCOME_TEXT':
      return { ...state, isWelcomeTextPassed: true };
    case 'PASS_CUSTOM_TERMS_FLOW_IS_EU':
      return { ...state, isCustomTrukcelFlowPrecheckDone: true };
    case 'PASS_CUSTOM_TERMS_FLOW_IS_NOT_EU':
      return { ...state, isCustomTrukcelFlowPrecheckDone: true, isTermsAccepted: true };
    case 'ACCEPT_TERMS':
      return { ...state, isTermsAccepted: true };
    case 'ACCEPT_FAIRNESS_AGREEMENT':
      return { ...state, isFairnessAccepted: true };
    case 'BIO_EDITED':
      return { ...state, isBioEdited: true };
    case 'TECH_ISSUES':
      return { ...state, isTechIssuesPassed: true };
    default:
      return state;
  }
};

const PreTestComponent = ({ history, onComplete, is360, welcomeText, areTermsSkipped }) => {
  // const DEFAULT_COMPLETE_BIO_TEMPLATE = 0;
  const DEFAULT_EMPTY_BIO_TEMPLATE = -1;

  const [bioTemplatesData, setBioTemplatesData] = useState([]);
  const userId = useSelector((state) => state.questionnaireDetails.details.userId);
  const isAdmisteredTest = useSelector((state) => state.questionnaireDetails.details.isAdministered) || false;
  const shouldSkipFairnessPage = useSelector((state) => state.questionnaireDetails.details.skipFairnessPage) || false;
  let selectedBiodataTemplateId = useSelector((state) => state.questionnaireDetails.details.biodataTemplateId);
  let selectedBiodataTemplate = bioTemplatesData.find((template) => template.id === selectedBiodataTemplateId);

  const questionnaireDetails = useSelector((state) => state.questionnaireDetails.details);
  // const shouldSkipCustomTerms = !useSelector((state) => state.questionnaireDetails.details.showEuCitizenPage) || false;
  const shouldSkipCustomTerms = (questionnaireDetails && !questionnaireDetails.showEuCitizenPage) || false;

  useEffect(() => {
    managementApi
      .fetchBiodataTemplates(userId)
      .then(({ data }) => {
        setBioTemplatesData(data);
      })
      .catch((e) => {
        console.error(e);
      });

    return () => {};
  }, []);

  if (bioTemplatesData.length === 0) {
    selectedBiodataTemplate = null;
    if (![0, -1].includes(selectedBiodataTemplateId)) {
      selectedBiodataTemplateId = DEFAULT_EMPTY_BIO_TEMPLATE;
    }
  }

  const onCancelHandler = React.useCallback(() => {
    history.push(is360 ? '/Start360' : '/Start');
  }, [history, is360]);

  const [state, dispatch] = React.useReducer(preTestReducer, {
    isTermsSkipped: areTermsSkipped,
    isCustomTrukcelFlow: !!questionnaireDetails.showEuCitizenPage,
    isCustomTrukcelFlowPrecheckDone: false,
    isTermsAccepted: areTermsSkipped,
    isFairnessAccepted: shouldSkipFairnessPage ? true : areTermsSkipped || is360 || isAdmisteredTest,
    isBioEdited: !shouldSkipCustomTerms ? true : areTermsSkipped || is360,
    isWelcomeTextPassed: !welcomeText,
    isTechIssuesPassed: shouldSkipFairnessPage ? areTermsSkipped : areTermsSkipped || is360 || isAdmisteredTest,
  });

  React.useEffect(() => {
    const { isWelcomeTextPassed, isTermsAccepted, isBioEdited, isTechIssuesPassed, isFairnessAccepted } = state;
    if (isWelcomeTextPassed && isTermsAccepted && isBioEdited && isTechIssuesPassed && isFairnessAccepted) {
      onComplete();
    }
  }, [state, onComplete]);

  // Note: The order of the screens depends on the postion on the SWITCH
  return React.useMemo(() => {
    switch (true) {
      case !state.isWelcomeTextPassed:
        return (
          <WelcomeText
            text={welcomeText}
            onNext={() => {
              dispatch({ type: 'PASS_WELCOME_TEXT' });
            }}
          />
        );
      case state.isCustomTrukcelFlow &&
        !state.isCustomTrukcelFlowPrecheckDone &&
        !state.isTermsAccepted &&
        !state.isTermsSkipped:
        return (
          <PreCustomGDPR
            onNotApply={() => {
              dispatch({ type: 'PASS_CUSTOM_TERMS_FLOW_IS_NOT_EU' });
            }}
            onApply={() => {
              dispatch({ type: 'PASS_CUSTOM_TERMS_FLOW_IS_EU' });
            }}
          />
        );
      case state.isCustomTrukcelFlow &&
        state.isCustomTrukcelFlowPrecheckDone &&
        !state.isTermsAccepted &&
        !state.isTermsSkipped:
        return (
          <CustomGDPR
            onCancel={onCancelHandler}
            onNext={() => {
              dispatch({ type: 'ACCEPT_TERMS' });
            }}
          />
        );
      case !state.isTermsSkipped && !state.isTermsAccepted:
        return (
          <Terms
            onCancel={onCancelHandler}
            onNext={() => {
              dispatch({ type: 'ACCEPT_TERMS' });
            }}
          />
        );
      case !state.isFairnessAccepted:
        return (
          <Fairness
            onCancel={onCancelHandler}
            onNext={() => {
              dispatch({ type: 'ACCEPT_FAIRNESS_AGREEMENT' });
            }}
          />
        );
      case !state.isBioEdited && shouldSkipCustomTerms:
        return (
          <Bio
            biodataTemplate={selectedBiodataTemplate}
            biodataTemplateId={selectedBiodataTemplateId}
            onBioEdited={() => dispatch({ type: 'BIO_EDITED' })}
          />
        );
      case !state.isTechIssuesPassed:
        return (
          <TechIssues
            is360={is360}
            onCancel={onCancelHandler}
            onNext={() => {
              dispatch({ type: 'TECH_ISSUES' });
            }}
          />
        );
      default:
        return <Spinner />;
    }
  }, [
    state.isWelcomeTextPassed,
    state.isTermsAccepted,
    state.isFairnessAccepted,
    state.isBioEdited,
    state.isTechIssuesPassed,
    welcomeText,
    onCancelHandler,
    state.isCustomTrukcelFlow,
    state.isCustomTrukcelFlowPrecheckDone,
  ]);
};

const mapStateToProps = (state) => {
  const {
    questionnaireDetails: {
      details: { isAdministered, welcomeText },
    },
  } = state;

  return {
    isAdministered,
    welcomeText,
  };
};

export const PreTest = compose(withRouter, connect(mapStateToProps))(PreTestComponent);
